module.exports = __webpack_public_path__ + "static/media/about.612d296d.png";